"use client";

import React from "react";
import { useAuth } from "@/lib/useAuth";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import PlatformLandingPage from "@/components/pages/PlatformLandingPage";
import SchoolLandingPage from "@/components/pages/SchoolLandingPage";
import { useSchool } from "@/lib/useSchool";

export default function HomePage() {
  const { loading: authLoading, loginWithGoogle } = useAuth();
  const { school, inSchoolContext, schoolSlug, schoolLoading } = useSchool();

  // Main render logic
  if (authLoading) {
    return (
      <Container maxWidth="sm">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  // If we're in a school context, show the school landing page
  if (inSchoolContext) {
    return (
      <SchoolLandingPage
        school={school}
        schoolSlug={schoolSlug}
        loading={schoolLoading}
        error={""}
        onLogin={loginWithGoogle}
      />
    );
  }

  // If not authenticated and not in school context, show platform landing page
  if (!inSchoolContext) {
    return <PlatformLandingPage onLogin={loginWithGoogle} />;
  }
}
